import React, { useRef, useState } from "react";
import StickyCartBtn from "../cartBtn/StickyCartBtn";
import CartSidebar from "../sideBar/CartSidebar";
import { fetchCartInfo } from "@/api/cart";
import { useSelector } from "react-redux";

function CartSidebarWrapper() {
  const cartSidebarRef = useRef();
  const [cartData, setCartData] = useState({});
  const [loading, setLoading] = useState(false);

  const cartItemsCount = useSelector((state) => state.cart.cartItemsCount);

  const onStickyCartClick = () => {
    cartSidebarRef.current?.makeCartSidebarVisible();
    getCartData();
  };

  const getCartData = async () => {
    if (cartItemsCount === 0) return;
    setLoading(true);
    let res = await fetchCartInfo();
    if (res?.data?.cart) {
      setCartData(res?.data?.cart);
      setLoading(false);
    }
  };

  return (
    <div>
      <StickyCartBtn
        onStickyCartClick={onStickyCartClick}
        cartItemsCount={cartItemsCount}
      />
      <CartSidebar
        cartItemsCount={cartItemsCount}
        data={cartData}
        ref={cartSidebarRef}
        isLoading={loading}
      />
    </div>
  );
}

export default CartSidebarWrapper;
